import { useMutation } from "@tanstack/react-query";
import { createTeamTariff } from "@src/entities/tariffs/api/request/createTeamTariff";
import { useNotificationStore } from "@src/shared/components/Notification";

export const useCreateTeamTariff = () => {
  const { showAlert } = useNotificationStore();
  const query = useMutation({
    mutationFn: createTeamTariff,
    onError: (error) => {
      showAlert(error.message, "error");
    },
  });
  return query;
};
